import {Widget} from '../../../../features/widgets/models/widget';
import {GridAddress} from '../../../../features/widgets/models/grid-address';
import {WidgetAction} from '../../../../features/widgets/models/widget-action';
import {WidgetCellStyleRule} from '../../../../features/widgets/models/widget-cell-style-rule';
import {WidgetTable} from '../../../../features/widgets/models/widget-table';
import {WidgetTableColumn} from '../../../../features/widgets/models/widget-table-column';

export enum WidgetName {
  BirthdayList = 'Birthdays',
  UpcomingReviews = 'Reviews',
  ClientSpecialOccasions = 'Client Special Occasions',
  PerformanceOverview = 'Performance Overview',
  ClientTypeAnalysis = 'Client Type Analysis',
  JeanetteMarais = 'Jeanette Marais',
  BigCombo = 'Big Combo',
  PendingServiceAgreements = 'Pending/Rejected Service Agreements',
  Leads = 'Leads to follow up',
}

const REVIEW_STATUS_STYLING_RULES: WidgetCellStyleRule[] = [
  {
    orderIndex: 1,
    condition: {
      criteria: 'EXACT_MATCH',
      values: ['Upcoming'],
      caseSensitive: false,
    },
    style: {
      color: '#3E9438',
      isBold: false,
      isItalic: false,
      isUnderlined: false,
    },
  },
  {
    orderIndex: 2,
    condition: {
      criteria: 'EXACT_MATCH',
      values: ['Overdue'],
      caseSensitive: false,
    },
    style: {
      color: '#C00004',
      isBold: false,
      isItalic: false,
      isUnderlined: false,
    },
  },
];

const SERVICE_AGREEMENT_STATUS_STYLING_RULES: WidgetCellStyleRule[] = [
  {
    orderIndex: 1,
    condition: {
      criteria: 'EXACT_MATCH',
      values: ['Rejected'],
      caseSensitive: false,
    },
    style: {
      color: '#C62828',
      isBold: true,
    },
  },
  {
    orderIndex: 2,
    condition: {
      criteria: 'EXACT_MATCH',
      values: ['Pending'],
      caseSensitive: false,
    },
    style: {
      color: '#18864B',
      isBold: true,
    },
  },
];

const LEAD_STATUS_STYLING_RULES: WidgetCellStyleRule[] = [
  {
    orderIndex: 1,
    condition: {
      criteria: 'CONTAINS',
      values: ['Contact'],
      caseSensitive: false,
    },
    style: {
      color: '#18864B',
      isBold: true,
    },
  },
];

export const MockWidgets: Widget[] = [
  {
    widgetKey: WidgetName.BirthdayList.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.BirthdayList,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.BirthdayList,
    defaultWidth: 7,
    defaultHeight: 4, // default size in grid blocks (columns x rows)
    enabled: true,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('Birthdays', 0, [
        createColumn('Client', 0, 'TEXT', 'clientName'),
        createColumn('Birthdate', 1, 'DATE', 'birthdate'),
        createColumn('Cell Phone no', 2, 'PHONE_NUMBER', 'contactNumber'),
        createActionColumn('Send Greeting', 3, 'emailAddress', {
          actionType: 'EMAIL',
          actionName: 'Send Greeting',
          icon: 'email',
          emailTemplate: 'BIRTHDAY_GREETING',
          linkTemplate: '',
        }),
      ]),
    ]
  },
  {
    widgetKey: WidgetName.UpcomingReviews.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.UpcomingReviews,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.UpcomingReviews,
    defaultWidth: 7,
    defaultHeight: 4, // default size in grid blocks (columns x rows)
    enabled: true,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('Reviews', 0, [
        createColumn('Client', 0, 'TEXT', 'clientName'),
        createColumn('Review date', 1, 'DATE', 'reviewDate'),
        createColumn('Status', 2, 'TEXT', 'status', REVIEW_STATUS_STYLING_RULES),
        createActionColumn('Manage review', 3, 'reviewId', {
          actionType: 'LINK',
          actionName: 'Manage review',
          icon: 'open_in_new',
          emailTemplate: '',
          linkTemplate: '/reviews/{reviewId}',
        }),
      ]),
    ]
  },
  {
    widgetKey: WidgetName.ClientSpecialOccasions.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.ClientSpecialOccasions,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.ClientSpecialOccasions,
    defaultWidth: 11,
    defaultHeight: 5, // default size in grid blocks (columns x rows)
    enabled: true,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('Special occasions', 0, [
        createColumn('Client', 0, 'TEXT', 'clientName'),
        createColumn('Occasion', 1, 'TEXT', 'occasion'),
        createColumn('Detail', 2, 'TEXT', 'detail'),
        createActionColumn('Actions', 3, 'clientKey', {
          actionType: 'LINK',
          actionName: 'View client',
          icon: 'open_in_new',
          emailTemplate: '',
          linkTemplate: '/client/{clientKey}',
        }),
      ]),
    ]
  },
  {
    widgetKey: WidgetName.PerformanceOverview.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.PerformanceOverview,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.PerformanceOverview,
    defaultWidth: 6,
    defaultHeight: 5,
    enabled: true,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: []
  },
  {
    widgetKey: WidgetName.ClientTypeAnalysis.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.ClientTypeAnalysis,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.ClientTypeAnalysis,
    defaultWidth: 6,
    defaultHeight: 5,
    enabled: false,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: []
  },
  {
    widgetKey: WidgetName.BigCombo.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.BigCombo,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.BigCombo,
    defaultWidth: 5,
    defaultHeight: 5,
    enabled: false,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('Test', 0, [
        createColumn('Metric', 0, 'TEXT', 'metric'),
        createColumn('Value', 1, 'TEXT', 'value'),
        createColumn('Change', 2, 'TEXT', 'change'),
      ]),
    ]
  },
  {
    widgetKey: WidgetName.PendingServiceAgreements.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.PendingServiceAgreements,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.PendingServiceAgreements,
    defaultWidth: 11,
    defaultHeight: 5,
    enabled: false,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('CSA', 0, [
        createColumn('Client', 0, 'TEXT', 'clientName'),
        createColumn('Client Type', 1, 'TEXT', 'clientType'),
        createColumn('Status', 2, 'TEXT', 'status', SERVICE_AGREEMENT_STATUS_STYLING_RULES),
        createActionColumn('Actions', 3, 'clientKey', {
          actionType: 'LINK',
          actionName: 'View client',
          icon: 'remove_red_eye',
          emailTemplate: '',
          linkTemplate: '/client/client-view?clientType={clientType}&clientKey={clientKey}',
        }),
      ]),
    ]
  },
  {
    widgetKey: WidgetName.Leads.replace(/\s+/g, '-').toLowerCase(),
    widgetName: WidgetName.Leads,
    widgetType: 'TABLE',
    showHeader: false,
    showFooter: false,
    title: WidgetName.Leads,
    defaultWidth: 7,
    defaultHeight: 5,
    enabled: false,
    isDragging: false,
    gridAddress: {} as GridAddress,
    tables: [
      createTable('Leads', 0, [
        createColumn('Lead Name', 0, 'TEXT', 'leadName'),
        createColumn('Status', 1, 'TEXT', 'status', LEAD_STATUS_STYLING_RULES),
        createActionColumn('Actions', 2, 'leadId', {
          actionType: 'LINK',
          actionName: 'View lead',
          icon: 'remove_red_eye',
          emailTemplate: '',
          linkTemplate: '/leads/detail/{leadId}',
        }),
      ]),
    ]
  },
];

function createTable(title: string, orderIndex: number, columns: WidgetTableColumn[]): WidgetTable {
  return {
    key: '0',
    title,
    orderIndex,
    columns,
    showHeader: true,
    primaryKey: ''
  };
}

function createColumn(
  header: string,
  orderIndex: number,
  type: WidgetTableColumn['type'],
  dataField: string,
  stylingRules: WidgetCellStyleRule[] = [],
): WidgetTableColumn {
  const column: WidgetTableColumn = {
    header,
    orderIndex,
    type,
    dataField,
    actions: [],
    defaultSortColumn: false,
    sortDisabled: false,
  };

  if (stylingRules.length > 0) {
    column.stylingRules = stylingRules;
  }

  return column;
}

function createActionColumn(
  header: string,
  orderIndex: number,
  dataField: string,
  action: WidgetAction,
): WidgetTableColumn {
  return {
    header,
    orderIndex,
    type: 'SINGLE_ACTION',
    dataField,
    actions: [action],
    defaultSortColumn: false,
    sortDisabled: true,
  };
}
